import { render, staticRenderFns } from "./ChangeButton.vue?vue&type=template&id=05e64f1e&scoped=true&"
import script from "./ChangeButton.vue?vue&type=script&lang=js&"
export * from "./ChangeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e64f1e",
  null
  
)

export default component.exports